import React, { FC } from 'react'
import isAuthenticated from '../../routes/PrivateRoute'
import MemberHome from '../MemberHome'
import Admin from '../Admin'
import useUserWithRole from '../../hooks/authentication/useUserWithRole'

const Home: FC = () => {
    const { role } = useUserWithRole()

    return (
        <>
            {role === 'member' && <MemberHome />}
            {role === 'admin' && <Admin />}
        </>
    )
}

export default isAuthenticated(Home)